<template>
  <Wrapper>
    <Header><h2 class="title">Calendário de monitoramento</h2></Header>
    <Main>
      <Container width="25%">
        <div class="header">
          <h3 class="title">Filtrar por</h3>
        </div>
        <div class="contents">
          <SubTitle>Meus territorórios</SubTitle>
            <LineCustom />
            <ul>
              <li style="padding-top: 5px; list-style-type: none;" v-for="i in territories" :key="i.id">
                <CheckBoxRound
                  :label="i.name"
                  :inputValue="i.id"
                  v-model="territoryCar"
                  :checked="hasChecked"
                />
              </li>
            </ul>
          <SubTitle>Meus Boletos</SubTitle>
            <ul>
              <li style="padding-top: 5px; list-style-type: none;" v-for="i in listNameTickets" :key="i">
                <CheckBoxRound
                  :label="i"
                  v-model="ticketObj"
                  :checked="hasCheckedTickets"
                />
              </li>
            </ul>
            <SubTitle>ACT Vigente</SubTitle>
            <ul>
              <li style="padding-top: 5px; list-style-type: none;" v-for="i in getActForCalendarData" :key="i.id">
                <CheckBoxRound
                  :label="i.customData.title"
                  :inputValue="i.key"
                  v-model="actData"
                  :checked="hasChecked"
                />
              </li>
            </ul>
            <span style="display: block; margin-top: 2rem;">
              <button class="clearFilter" @click="clearFilter">- Limpar Tudo</button>
            </span>
        </div>
        <div class="header">
          <h3 class="title">Legenda</h3>
        </div>
        <div class="contents">
          <ul class="filters">
            <li class="legendBlue">Geomonitoramento</li>
            <li class="legendOrange">Autovistoria</li>
          </ul>
        </div>
      </Container>
      <CalendarContainer>
        <v-calendar
          ref="calendar"
          class="custom-calendar"
          :masks="masks"
          :attributes="dates"
          disable-page-swipe
        >
          <template v-slot:day-content="{ day, attributes }">
            <div class="itemContainer">
              <span class="dayItem">{{ day.day }}</span>
              <div class="contentItem">
                <p
                  v-for="attr in attributes"
                  :key="attr.key"
                  class="text"
                  :class="attr.customData.class"
                  @click="toggleDate(attr)"
                >
                  {{ attr.customData.title }}
                </p>
              </div>
            </div>
          </template>
        </v-calendar>
      </CalendarContainer>
      <Container style="padding: 15px;" width="30%">
        <SubTitle>Período</SubTitle>
            <LineCustom />
            <div>
              <Select
                :options="getDatesEnable()"
                default="Selecione uma data"
                class="select"
                @input="handleSelect"
                messageEmpty="Nenhuma data encontrada"
              />
            </div>
            <SubTitle><br>Vencimento dos boletos</SubTitle>
            <LineCustom />
            <div>
              <Select
                :options="getDatesEnablePayment()"
                default="Selecione uma data"
                class="select"
                @input="handleSelect"
                messageEmpty="Nenhuma data encontrada"
              />
            </div>
            <LineCustom />
            <div v-show="linkGix != ''">
              <a class="link" :href="linkGix"><Link />  Link do Gix</a>
            </div>
      </Container>
    </Main>
  </Wrapper>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
// import Checkbox from '@/components/Checkbox/index.vue';
import { mapGetters, mapActions } from 'vuex';
import CheckBoxRound from '@/components/CheckBoxRound/index.vue';
import Select from '@/components/Select/index.vue';
import { removeMaskDocument } from '@/utils';
import getTerritoryByAgentDocumentService from '@/services/territory/get-territory-by-agent-document';
import { generateLinkGix } from '@/services/gix/generate-link-gix';
import {
  Wrapper, Header, Main, Container, CalendarContainer,
} from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    Header,
    Main,
    Container,
    CheckBoxRound,
    CalendarContainer,
    Select,
  },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      linkGix: '',
      dates: [],
      territories: [],
      colors: ['blue', 'orange', 'red', 'black'],
      listNameTickets: ['Boletos'],
      territoryCar: [],
      ticketObj: [],
      actData: [],
      actDataObj: [],
      cdTerritory: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged')),
      hasChecked: true,
      hasCheckedTickets: false,
      tickets: [{
        duedate: '',
        status: '',
        ticketId: 0,
        ticketName: '',
      }],
      getPaymentForCalendarData: [{
        key: '',
        dates: '',
        customData: {
          title: '',
          class: 'yellow',
        },
        id: '',
        color: 'yellow',
        cdTerritory: 0,
        territoryName: '',
      }],
      getActForCalendarData: [{
        key: '',
        dates: '',
        customData: {
          title: 'ACT',
          class: 'yellow',
        },
        id: '',
        color: 'yellow',
      }],
    };
  },
  computed: {
    ...mapGetters(['getAppointmentForCalendar', 'ticket', 'act']),
  },
  methods: {
    ...mapActions({
      getAppointmentDate: 'getAppointmentDate',
      getAppointmentRequest: 'getAppointmentRequest',
      getTickets: 'getTickets',
      getAct: 'getAct',
    }),
    getDatesEnablePayment() {
      return this.filterParamsCheckedsPayment().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.territoryName}`,
      );
    },
    getDatesAct() {
      return this.filterParamsCheckedsAct().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.customData.title}`,
      );
    },
    goToTerritory() {
      this.$router.push({ name: 'Prod' });
    },
    goToGeo(dataType, dataInitial, dataEnd, car) {
      if (dataType !== 'orange') {
        this.$router.push({
          name: 'Autovistoria',
          params: { dataInitial, dataEnd, car },
        });
      } else {
        this.$router.push({
          name: 'Geomonitoramento',
          params: { dataInitial, dataEnd, car },
        });
      }
    },
    toggleDate(dateInfo) {
      const { dates, customData } = dateInfo;
      const { start } = dates[0];
      const getAppointment = this.getAppointmentForCalendar;
      const isDate = (appointment) => moment(appointment.dates).isSame(start)
        && customData.class === appointment.customData.class;

      const isEqualDate = getAppointment.find(isDate);

      if (isEqualDate) {
        const SEVEN_DAYS = 7;
        const dateEnd = moment(start).add(SEVEN_DAYS, 'days').format('DD/MM/YYYY');
        const dateInitialFormat = moment(start).format('DD/MM/YYYY');
        this.goToGeo(isEqualDate.customData.class, dateInitialFormat, dateEnd, isEqualDate.car);
      }
    },
    removeChecked(value, arr) {
      const index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    filterParamsCheckeds() {
      return this.getAppointmentForCalendar
        .filter((ap) => this.territoryCar.includes(ap.id))
        .filter((ap) => this.colors.includes(ap.color));
    },
    clearFilter() {
      this.territoryCar.length = 0;
      this.colors.length = 0;
      this.hasChecked = false;
      this.dates = this.filterParamsCheckeds();
    },
    async getTerritories() {
      const { stDocument } = this.userLoged;
      const formattedValue = removeMaskDocument(stDocument);
      this.territories = await getTerritoryByAgentDocumentService(formattedValue);
    },
    formatNote() {
      return this.territories.map((territory) => ({
        id: territory.id,
        agentId: territory.agents[0].id,
        tokenKey: this.userLoged.company.stKey,
      }));
    },
    async setAppointmentInNotification() {
      const territoriesFormat = this.formatNote();

      await this.getAppointmentRequest({ territoriesFormat });
    },
    async handleSelect(value) {
      const { calendar } = this.$refs;
      const date = moment(value, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    async moveCalenderTickets() {
      const { calendar } = this.$refs;
      const date = moment(this.getPaymentForCalendarData[0].dates, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    async moveCalenderAct() {
      const { calendar } = this.$refs;
      const date = moment(this.getActForCalendarData[0].dates, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    filterParamsCheckedsPayment() {
      return this.getPaymentForCalendarData;
    },
    filterParamsCheckedsAct() {
      return this.getActForCalendarData
        .filter((ap) => this.actData.includes(ap.id))
        .filter((ap) => this.colors.includes(ap.color));
    },
    async moveInitialDate() {
      const { calendar } = this.$refs;
      const firstDate = this.dates[0];
      const parseDate = moment(firstDate.dates, 'L');

      await calendar.move({ month: parseDate.month() + 1, year: parseDate.year() });
    },
    getDatesEnable() {
      return this.filterParamsCheckeds().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.customData.title}`,
      );
    },
    getGenerateGixLinkRequest(cdTerritory) {
      const params = {
        TokenKey: this.userLoged.company.stKey,
        CdUser: this.userLoged.idUser,
        CdTerritory: cdTerritory,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.linkGix = data;
      });
    },
    watchFilters() {
      this.$watch(
        (vm) => [vm.territoryCar, vm.colors, vm.getAppointmentForCalendar],
        () => {
          this.dates = this.filterParamsCheckeds();
          this.moveInitialDate();
        },
      );
    },
  },
  watch: {
    territoryCar() {
      this.hasChecked = !this.hasChecked;
      this.check = !this.check;
      this.cdTerritory = this.territoryCar;
      this.getGenerateGixLinkRequest(this.territoryCar[0]);
      this.getPaymentForCalendarData = [];
      this.territoryCar.forEach((t) => {
        this.getTickets({ cdTerritory: t }).then(() => {
          this.tickets = this.ticket.data.objectResult;
          this.ticket.data.objectResult.forEach((e) => {
            const territoryVar = this.territories.filter((t) => t.id === e.cdTerritory);
            const territoryNameVar = territoryVar[0].name;
            this.getPaymentForCalendarData.push({
              key: e.ticketId,
              dates: new Date(e.dueDate),
              customData: {
                title: e.ticketName,
                class: 'black',
              },
              id: e.ticketId,
              color: 'black',
              cdTerritory: e.cdTerritory,
              status: e.status,
              territoryName: territoryNameVar,
            });
          });
        });
      });
      const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
      this.getAct({ tokenKey: company.stKey, cdTerritory: this.cdTerritory[0] }).then(() => {
        this.actDataObj = this.act.data.objectResult[this.act.data.objectResult.length - 1];
        // this.getActForCalendarData[0].key = this.actDataObj.id;
        this.getActForCalendarData[0].dates = new Date(this.actDataObj.act);
        this.getActForCalendarData[0].customData.title = 'Act Vigente';
        this.getActForCalendarData[0].customData.class = 'red';
        this.getActForCalendarData[0].id = this.actDataObj.id;
        this.getActForCalendarData[0].color = 'red';
      });
    },
    ticketObj() {
      this.hasCheckedTickets = !this.hasCheckedTickets;
      this.moveCalenderTickets();
      if (this.hasCheckedTickets === true) {
        this.dates = this.getPaymentForCalendarData;
      } else if (this.hasCheckedTickets === false) {
        this.dates = this.filterParamsCheckeds();
      }
    },
    actData() {
      this.moveCalenderAct();
      const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
      this.getAct({ tokenKey: company.stKey, cdTerritory: this.cdTerritory[0] }).then(() => {
        this.actDataObj = this.act.data.objectResult[this.act.data.objectResult.length - 1];
        this.getActForCalendarData[0].key = this.actDataObj.id;
        this.getActForCalendarData[0].dates = new Date(this.actDataObj.act);
        this.getActForCalendarData[0].customData.title = 'Act Vigente';
        this.getActForCalendarData[0].customData.class = 'red';
        this.getActForCalendarData[0].id = this.actDataObj.id;
        this.getActForCalendarData[0].color = 'red';
        this.dates = this.getActForCalendarData;
      });
    },
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.formContainer,
    });
    this.getPaymentForCalendarData.shift();
    await this.getTerritories();

    if (this.getAppointmentForCalendar.length === 0) {
      await this.setAppointmentInNotification();
    }
    this.watchFilters();
    loader.hide();
  },
});
</script>
